import * as React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import { IDiseaseCategory } from '../../models/IDiseaseCategory';
import { ITherapy } from '../../models/ITherapy';
import { ICombinedSearchItem } from '../../models/ICombinedSearchItem';
import { SearchService } from '../../services/SearchService';
import { IBasicSearchData } from '../../models/IBasicSearchData';
import { IPlace } from '../../models/IPlace';
import { PlaceSearch } from '../Search/PlaceSearch';
import './Search.css';
import {
	SetBasicSearchDataAndResetAdvancedCriteria,
	SetAdvancedSearchData,
} from '../../actions/ActionsIndex';
import { LoaderComponent } from '../../controls/Loader';
import { GetGeolocation } from '../../utils/Geolocation';
import { ISearchSelectedItem } from '../../models/ISearchSelectedItem';
import { RedirectWithRouter } from '../Layout/Layout';
import { SimplifyString } from '../../utils/String';
import { IsNullEmptyOrUndefined } from '../../utils/IsNullEmptyOrUndefined';
import { TELE_PLACE } from '../../constants/TelePlace';
import { IAdvancedSearchData } from 'src/models/IAdvancedSearchData';

function MapState(state) {
	return {
		Criteria: state.SearchData.CriteriaInputValue
			? state.SearchData.CriteriaInputValue
			: '',
		Place: state.SearchData.PlaceInputValue
			? state.SearchData.PlaceInputValue
			: undefined,
		CriteriaInputSelectedItem: state.SearchData.CriteriaInputSelectedItem,
		AdvancedSearchData: {
			SelectedDiseases: state.SearchData.SelectedDiseases,
			SelectedTherapies: state.SearchData.SelectedTherapies,
			SelectedDateFrom: state.SearchData.SelectedDateFrom,
			SelectedDateTo: state.SearchData.SelectedDateTo,
			SortOrder: state.SearchData.SortOrder,
			FilterType: state.SearchData.FilterType,
			CurrentPage: state.SearchData.CurrentPage,
		},
	};
}

interface IProps {
	SaveBasicSearch: (data: IBasicSearchData) => void;
	SaveAdvancedSearch: (data: IAdvancedSearchData) => void;
	AdvancedSearchData: IAdvancedSearchData;
	Criteria: string;
	Place?: IPlace;
	CriteriaInputSelectedItem?: ISearchSelectedItem;
	ShowLocationInput?: boolean;
}

interface IState {
	Criteria: string;
	Place?: IPlace;
	CriteriaDropDownOpen: boolean;
	PlaceDropDownOpen: boolean;
	DiseasesTabActive: boolean;
	TherapiesTabActive: boolean;
	DiseasesList: IDiseaseCategory[];
	TherapiesList: ITherapy[];
	PlacesList: IPlace[];
	IsCriteriaChangedByUser: boolean;
	CombinedSearchList: ICombinedSearchItem[];
	CriteriaLoaderVisible: boolean;
	CriteriaSelectedItem?: ISearchSelectedItem;
	SelectedTab: string;
}

enum selectedTab {
	'gabinet' = 1,
	'domowa' = 2,
	'telerehabilitacja' = 3,
}

class BasicSearchCriteriaComponent extends Component<IProps, IState> {
	private dataRefreshTimeout: any;
	private CriteriaDropDownContainerNode: Node | null;
	private PlaceSearchNode: PlaceSearch | null;

	constructor(props) {
		super(props);
		this.state = {
			Criteria: this.props.Criteria,
			Place:
				this.props.Place === undefined || this.props.Place === null
					? undefined
					: this.props.Place,
			CriteriaSelectedItem: this.props.CriteriaInputSelectedItem,
			CriteriaDropDownOpen: false,
			PlaceDropDownOpen: false,
			DiseasesTabActive: true,
			TherapiesTabActive: false,
			DiseasesList: [],
			TherapiesList: [],
			PlacesList: [],
			IsCriteriaChangedByUser: false,
			CombinedSearchList: [],
			CriteriaLoaderVisible: false,
			SelectedTab: this.props.AdvancedSearchData.FilterType
				? selectedTab[this.props.AdvancedSearchData.FilterType]
				: this.props.Place && this.props.Place.id === 'TELEREHABILITACJA'
				? selectedTab[3]
				: selectedTab[1],
		};

		this.OpenCriteriaDropDown = this.OpenCriteriaDropDown.bind(this);
		this.OpenPlaceDropDown = this.OpenPlaceDropDown.bind(this);
		this.ClosePlaceDropDown = this.ClosePlaceDropDown.bind(this);
		this.OnDiseasesTabClick = this.OnDiseasesTabClick.bind(this);
		this.OnTherapiesTabClick = this.OnTherapiesTabClick.bind(this);
		this.OnGetAllCategoriesSuccess = this.OnGetAllCategoriesSuccess.bind(this);
		this.OnGetAllCategoriesError = this.OnGetAllCategoriesError.bind(this);
		this.OnCriteriaChange = this.OnCriteriaChange.bind(this);
		this.OnPlaceChange = this.OnPlaceChange.bind(this);
		this.HandleClickOutside = this.HandleClickOutside.bind(this);
		this.RefreshCriteriaCombinedItems =
			this.RefreshCriteriaCombinedItems.bind(this);
		this.OnGetCombinedDataSuccess = this.OnGetCombinedDataSuccess.bind(this);
		this.OnGetCombinedDataError = this.OnGetCombinedDataError.bind(this);
		this.OnSearchClick = this.OnSearchClick.bind(this);
		this.OnSelectedPlace = this.OnSelectedPlace.bind(this);
		this.SetDefaultPlace = this.SetDefaultPlace.bind(this);
		this.OnGetClosestCitySuccess = this.OnGetClosestCitySuccess.bind(this);
		this.OnGetClosestCityError = this.OnGetClosestCityError.bind(this);
		this.OnPlaceDetailsReceived_OnSearchClick =
			this.OnPlaceDetailsReceived_OnSearchClick.bind(this);
		this.SearchPlace = this.SearchPlace.bind(this);

		let service = new SearchService();
		service.GetAllCategories(
			this.OnGetAllCategoriesSuccess,
			this.OnGetAllCategoriesError
		);

		GetGeolocation(this.SetDefaultPlace);
	}

	public componentWillMount() {
		document.addEventListener('click', this.HandleClickOutside, false);
	}

	public componentWillUnmount() {
		document.removeEventListener('click', this.HandleClickOutside, false);
	}

	public componentWillReceiveProps(nextProps: IProps) {
		this.setState({
			Criteria: nextProps.Criteria,
			Place: nextProps.Place,
			CriteriaSelectedItem: nextProps.CriteriaInputSelectedItem,
		});
	}

	public render() {
		const { SelectedTab } = this.state;
		return (
			<div className='basic-search-criteria'>
				<div className='basic-search-criteria__tabs'>
					{this.RenderTab('W gabinecie', selectedTab[1])}
					{this.RenderTab('W domu', selectedTab[2])}
					{this.RenderTab('Telerehabilitacja', selectedTab[3])}
				</div>
				<div className='basic-search-criteria-component search-inputs'>
					<div className='criteria-section'>
						<div
							className='select-container'
							ref={(node) => (this.CriteriaDropDownContainerNode = node)}
							tabIndex={-1}
						>
							<input
								type='text'
								autoComplete='off'
								name='Criteria'
								value={this.state.Criteria}
								className='form-control'
								placeholder={'Nazwisko, schorzenie lub terapia'}
								onFocus={this.OpenCriteriaDropDown}
								onChange={this.OnCriteriaChange}
							/>
							{this.RenderCriteriaDropDown()}
						</div>
					</div>
					{(SelectedTab !== selectedTab[3] || this.props.ShowLocationInput) && (
						<div className='place-section'>{this.RenderPlaceInput()}</div>
					)}
					<div className='button-section'>
						<button className='std-primary-btn' onClick={this.OnSearchClick}>
							Szukaj
						</button>
					</div>
				</div>
			</div>
		);
	} //end-of-render

	public Search(selectedItem: ISearchSelectedItem) {
		if (this.PlaceSearchNode !== null) {
			let selectedPlace: IPlace | undefined =
				this.PlaceSearchNode.GetSelectedPlace();
			if (selectedPlace === undefined) {
				if (this.state.SelectedTab === selectedTab[3]) {
					this.props.SaveBasicSearch({
						CriteriaInputSelectedItem: this.props.CriteriaInputSelectedItem,
						CriteriaInputValue: this.props.Criteria,
						PlaceInputValue: TELE_PLACE,
					});
					RedirectWithRouter(
						'/szukaj/' +
							SimplifyString('Telerehabilitacja') +
							(IsNullEmptyOrUndefined(selectedItem.Name)
								? ''
								: '/' + SimplifyString(selectedItem.Name))
					);
				} else {
					this.PlaceSearchNode.OpenDropDown();
				}
			} else {
				this.props.SaveBasicSearch({
					CriteriaInputValue: selectedItem.Name,
					PlaceInputValue: selectedPlace,
					CriteriaInputSelectedItem: selectedItem,
				});
				RedirectWithRouter(
					'/szukaj/' +
						SimplifyString(selectedPlace.name) +
						(IsNullEmptyOrUndefined(selectedItem.Name)
							? ''
							: '/' + SimplifyString(selectedItem.Name))
				);
			}
		}
	}

	public SearchPlace(selectedPlace: IPlace) {
		this.props.SaveBasicSearch({
			CriteriaInputSelectedItem: this.props.CriteriaInputSelectedItem,
			CriteriaInputValue: this.props.Criteria,
			PlaceInputValue: selectedPlace,
		});
		RedirectWithRouter(
			'/szukaj/' +
				SimplifyString(selectedPlace.name) +
				(IsNullEmptyOrUndefined(this.props.Criteria)
					? ''
					: '/' + SimplifyString(this.props.Criteria))
		);
	}

	private OnTabSelect = (type: 'gabinet' | 'domowa' | 'telerehabilitacja') => {
		this.setState({
			SelectedTab: type,
		});
		if (type === selectedTab[3]) {
			this.props.SaveAdvancedSearch({
				...this.props.AdvancedSearchData,
				FilterType: selectedTab[type],
			});
		} else {
			this.props.SaveBasicSearch({
				CriteriaInputSelectedItem: this.props.CriteriaInputSelectedItem,
				CriteriaInputValue: this.props.Criteria,
				PlaceInputValue: undefined,
			});
			this.props.SaveAdvancedSearch({
				...this.props.AdvancedSearchData,
				FilterType: selectedTab[type],
			});
		}
	};

	private RenderTab = (text: string, tab: string) => {
		return (
			<div
				onClick={this.OnTabSelect.bind(this, tab)}
				className={`basic-search-criteria__tab ${
					this.state.SelectedTab === tab
						? 'basic-search-criteria__tab--selected'
						: ''
				}`}
			>
				<div
					className={`basic-search-criteria__icon basic-search-criteria__icon--${tab}`}
				/>
				<p className='basic-search-criteria__title'>{text}</p>
			</div>
		);
	};

	private RenderCriteriaDropDown() {
		if (this.state.CriteriaDropDownOpen) {
			if (this.state.IsCriteriaChangedByUser) {
				return (
					<div className='criteria-drop-down-container drop-down-container'>
						{this.RenderCombinedCriteriaDropDownList()}
					</div>
				);
			} else {
				return (
					<div className='criteria-drop-down-container drop-down-container'>
						<div className='drop-down-header'>
							<span
								className={this.state.DiseasesTabActive ? 'active' : ''}
								onClick={this.OnDiseasesTabClick}
							>
								Schorzenia
							</span>
							<span
								className={this.state.TherapiesTabActive ? 'active' : ''}
								onClick={this.OnTherapiesTabClick}
							>
								Terapie
							</span>
						</div>
						{this.RenderCriteriaDropDownList()}
					</div>
				);
			}
		} else {
			return null;
		}
	}

	private RenderCriteriaDropDownList() {
		if (this.state.DiseasesTabActive) {
			let allItems = this.state.DiseasesList.slice(3).map((item) => (
				<li key={item.Id} onClick={this.OnDiseaseClick.bind(this, item.Id)}>
					{item.Name}
				</li>
			));
			const frequentItems = this.state.DiseasesList.slice(0, 3).map((item) => (
				<li key={item.Id} onClick={this.OnDiseaseClick.bind(this, item.Id)}>
					{item.Name}
				</li>
			));
			return (
				<div className='scrollable'>
					<div className='tab-list-title'>najczęstsze</div>
					<ul className='diseases-tab-list'>{frequentItems}</ul>
					<div className='tab-list-title'>wszystkie</div>
					<ul className='diseases-tab-list'>{allItems}</ul>
				</div>
			);
		} else if (this.state.TherapiesTabActive) {
			let allItems = this.state.TherapiesList.slice(3).map((item) => (
				<li key={item.Id} onClick={this.OnTherapyClick.bind(this, item.Id)}>
					{item.Name}
				</li>
			));
			const frequentItems = this.state.TherapiesList.slice(0, 3).map((item) => (
				<li key={item.Id} onClick={this.OnTherapyClick.bind(this, item.Id)}>
					{item.Name}
				</li>
			));
			return (
				<div className='scrollable'>
					<div className='tab-list-title'>najczęstsze</div>
					<ul className='therapies-tab-list'>{frequentItems}</ul>
					<div className='tab-list-title'>wszystkie</div>
					<ul className='therapies-tab-list'>{allItems}</ul>
				</div>
			);
		} else {
			setTimeout(
				(t) => {
					t.setState({
						DiseasesTabActive: true,
					});
				},
				500,
				this
			);
			return null;
		}
	}

	private RenderCombinedCriteriaDropDownList() {
		let items = this.state.CombinedSearchList.map((item) => (
			<li
				key={item.Type + '_' + item.Id}
				onClick={this.OnCombinedCriteriaItemClick.bind(this, item)}
			>
				{item.Type === 'Physiotherapist' ? (
					item.ImgUrl === null ? (
						<img src={'/images/default_profile_pic.svg'} />
					) : (
						<img src={item.ImgUrl} />
					)
				) : null}
				{item.Name}
			</li>
		));

		return (
			<div className='scrollable'>
				<LoaderComponent Visible={this.state.CriteriaLoaderVisible} />
				<ul className='combined-tab-list'>
					{items.length < 1 && !this.state.CriteriaLoaderVisible ? (
						<p>Brak wyników</p>
					) : (
						items
					)}
				</ul>
			</div>
		);
	}

	private OnSelectedPlace(place: IPlace) {
		this.setState({
			Place: place,
		});
	}

	private RenderPlaceInput() {
		return (
			<PlaceSearch
				ref={(node) => (this.PlaceSearchNode = node)}
				Value={this.state.Place}
				DefaultCities={this.state.PlacesList}
				OnSelectedPlace={this.OnSelectedPlace}
				OnPlaceDetailsReceived={this.OnPlaceDetailsReceived_OnSearchClick}
			/>
		);
	}

	private OpenCriteriaDropDown(e) {
		this.setState({
			CriteriaDropDownOpen: true,
		});
	}

	private OpenPlaceDropDown(e) {
		this.setState({
			PlaceDropDownOpen: true,
		});
	}

	private ClosePlaceDropDown(e) {
		setTimeout(
			(t) => {
				t.setState({
					PlaceDropDownOpen: false,
				});
			},
			250,
			this
		);
	}

	private OnDiseasesTabClick(e) {
		this.setState({
			DiseasesTabActive: true,
			TherapiesTabActive: false,
			CriteriaDropDownOpen: true,
		});
	}

	private OnTherapiesTabClick() {
		this.setState({
			TherapiesTabActive: true,
			DiseasesTabActive: false,
			CriteriaDropDownOpen: true,
		});
	}

	private OnGetAllCategoriesSuccess(result) {
		this.setState({
			DiseasesList: result.data.Value.DiseaseCategories,
			TherapiesList: result.data.Value.Therapies,
		});
	}

	private OnGetAllCategoriesError(error) {
		console.error(error);
	}

	private OnCriteriaChange(e) {
		if (e.target.value === '') {
			this.setState({
				Criteria: e.target.value,
				IsCriteriaChangedByUser: false,
				CriteriaDropDownOpen: true,
				CriteriaSelectedItem: undefined,
			});
			clearTimeout(this.dataRefreshTimeout);
		} else {
			this.setState({
				Criteria: e.target.value,
				IsCriteriaChangedByUser: true,
				CriteriaDropDownOpen: true,
				CriteriaSelectedItem: undefined,
			});
			if (this.dataRefreshTimeout) {
				clearTimeout(this.dataRefreshTimeout);
				this.dataRefreshTimeout = undefined;
			}
			this.dataRefreshTimeout = setTimeout(
				(t) => {
					t.RefreshCriteriaCombinedItems();
					clearTimeout(t.dataRefreshTimeout);
				},
				350,
				this
			);
		}
	}

	private OnPlaceChange(e) {
		this.setState({
			Place: e.target.value,
		});
		if (this.dataRefreshTimeout) {
			clearTimeout(this.dataRefreshTimeout);
			this.dataRefreshTimeout = undefined;
		}
		this.dataRefreshTimeout = setTimeout(
			(t) => {
				t.RefreshPlacesList();
				clearTimeout(t.dataRefreshTimeout);
			},
			350,
			this
		);
	}

	private HandleClickOutside(e: MouseEvent) {
		if (this.CriteriaDropDownContainerNode !== null) {
			if (
				this.CriteriaDropDownContainerNode.contains(e.target as HTMLElement)
			) {
				this.setState({
					CriteriaDropDownOpen: true,
				});
			} else {
				if (this.state.CriteriaDropDownOpen === true) {
					this.setState({
						CriteriaDropDownOpen: false,
					});
				}
			}
		}
	}

	private OnPlaceDetailsReceived_OnSearchClick(place: IPlace) {
		this.props.SaveBasicSearch({
			CriteriaInputValue: this.state.Criteria,
			PlaceInputValue: place,
			CriteriaInputSelectedItem: this.state.CriteriaSelectedItem,
		});
		RedirectWithRouter(
			'/szukaj/' +
				SimplifyString(place.name) +
				(IsNullEmptyOrUndefined(this.state.Criteria)
					? ''
					: '/' + SimplifyString(this.state.Criteria))
		);
	}

	private OnSearchClick(e) {
		if (
			this.state.SelectedTab === selectedTab[3] &&
			!this.props.ShowLocationInput
		) {
			this.props.SaveBasicSearch({
				CriteriaInputSelectedItem: this.state.CriteriaSelectedItem,
				CriteriaInputValue: this.state.Criteria,
				PlaceInputValue: TELE_PLACE,
			});
			RedirectWithRouter(
				'/szukaj/' +
					SimplifyString('Telerehabilitacja') +
					(IsNullEmptyOrUndefined(this.state.Criteria)
						? ''
						: '/' + SimplifyString(this.state.Criteria))
			);
		} else {
			if (this.PlaceSearchNode !== null) {
				let selectedPlace: IPlace | undefined =
					this.PlaceSearchNode.GetSelectedPlace();
				if (selectedPlace === undefined) {
					this.PlaceSearchNode.OpenDropDown();
				} else {
					this.props.SaveBasicSearch({
						CriteriaInputValue: this.state.Criteria,
						PlaceInputValue: selectedPlace, //this.state.Place,
						CriteriaInputSelectedItem: this.state.CriteriaSelectedItem,
					});
					RedirectWithRouter(
						'/szukaj/' +
							SimplifyString(selectedPlace.name) +
							(IsNullEmptyOrUndefined(this.state.Criteria)
								? ''
								: '/' + SimplifyString(this.state.Criteria))
					);
				}
			}
		}
	}

	private OnDiseaseClick(id: number, evt) {
		this.state.DiseasesList.forEach((item) => {
			if (item.Id === id) {
				this.setState({
					Criteria: item.Name,
					CriteriaDropDownOpen: false,
					IsCriteriaChangedByUser: false,
					CriteriaSelectedItem: {
						Id: item.Id,
						Name: item.Name,
						Type: 'DiseaseCategory',
					},
				});
			}
		});
	}

	private OnTherapyClick(id: number, evt) {
		this.state.TherapiesList.forEach((item) => {
			if (item.Id === id) {
				this.setState({
					Criteria: item.Name,
					CriteriaDropDownOpen: false,
					IsCriteriaChangedByUser: false,
					CriteriaSelectedItem: {
						Id: item.Id,
						Name: item.Name,
						Type: 'Therapy',
					},
				});
			}
		});
	}

	private OnCombinedCriteriaItemClick(item: ICombinedSearchItem, evt) {
		if (item.Type === 'Physiotherapist') {
			this.setState({
				Criteria: item.Name,
				CriteriaDropDownOpen: false,
				IsCriteriaChangedByUser: false,
				CriteriaSelectedItem: undefined,
			});
			RedirectWithRouter('/fizjoterapeuta/' + item.Id);
		} else {
			this.setState({
				Criteria: item.Name,
				CriteriaDropDownOpen: false,
				IsCriteriaChangedByUser: false,
				CriteriaSelectedItem: {
					Id: item.Id,
					Name: item.Name,
					Type: item.Type === 'DiseaseCategory' ? 'DiseaseCategory' : 'Therapy',
				},
			});
		}
	}

	private RefreshCriteriaCombinedItems() {
		let service = new SearchService();
		this.setState({
			CriteriaLoaderVisible: true,
		});
		service.GetCombainedSearchData(
			this.state.Criteria,
			this.OnGetCombinedDataSuccess,
			this.OnGetCombinedDataError
		);
	}

	private OnGetCombinedDataSuccess(result) {
		this.setState({
			CombinedSearchList: result.data.Value,
			CriteriaLoaderVisible: false,
		});
	}

	private OnGetCombinedDataError(error) {
		this.setState({
			CriteriaLoaderVisible: false,
		});
	}

	private SetDefaultPlace(position: Position) {
		let service = new SearchService();
		service.GetClosestCity(
			position.coords.latitude,
			position.coords.longitude,
			this.OnGetClosestCitySuccess,
			this.OnGetClosestCityError
		);
	}

	private OnGetClosestCitySuccess(result) {
		if (this.state.Place === undefined) {
			this.setState({
				Place: result.data.Value,
			});
		}
	}

	private OnGetClosestCityError(error) {
		console.error(error);
	}
}

export default connect(
	MapState,
	{
		SaveBasicSearch: SetBasicSearchDataAndResetAdvancedCriteria,
		SaveAdvancedSearch: SetAdvancedSearchData,
	},
	null,
	{ forwardRef: true }
)(BasicSearchCriteriaComponent);



// WEBPACK FOOTER //
// ./src/components/Search/BasicSearchCriteria.tsx